(function(){
  if (window.__ssInit) return; window.__ssInit = true;

  function initGallery(root){
    var track = root.querySelector('[data-ss-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = root.querySelectorAll('[data-ss-thumb]');
    var dots = root.querySelectorAll('[data-ss-dot]');
    function go(i){ track.scrollTo({left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth'}); }
    function mark(i){
      thumbs.forEach(function(t,k){ t.setAttribute('aria-current', k===i); });
      dots.forEach(function(d,k){ d.setAttribute('aria-current', k===i); });
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ go(i); mark(i); }); });
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ go(i); mark(i); }); });
    var raf;
    track.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){ mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, {passive: true});
  }

  // Paket seçimi: adet alanını ve buton/bar fiyatını günceller. Fiyat metni Liquid'in biçimlendirdiği karttan alınır.
  function initBundles(root){
    var cards = root.querySelectorAll('[data-ss-bundle]');
    var qty = root.querySelector('[data-ss-qty]');
    var labels = root.querySelectorAll('[data-ss-total]');
    if (!cards.length || !qty) return;
    function select(card){
      cards.forEach(function(c){ c.classList.toggle('is-active', c === card); });
      card.querySelector('input').checked = true;
      qty.value = card.dataset.qty;
      var price = card.querySelector('.ss-bundle__now');
      if (price) labels.forEach(function(l){ l.textContent = price.textContent.trim(); });
      document.dispatchEvent(new CustomEvent('ss:bundle', {detail: {qty: +card.dataset.qty}}));
    }
    cards.forEach(function(c){
      c.querySelector('input').addEventListener('change', function(){ select(c); });
    });
    var start = root.querySelector('[data-ss-bundle] input:checked');
    if (start) select(start.closest('[data-ss-bundle]'));
  }

  function addBusinessDays(d, n){
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function initDelivery(root){
    var box = root.querySelector('[data-ss-delivery]');
    if (!box) return;
    var cutoff = parseInt(box.dataset.cutoff, 10) || 14;
    var min = parseInt(box.dataset.min, 10) || 1;
    var max = parseInt(box.dataset.max, 10) || 3;
    var now = new Date();
    var ship = new Date(now);
    var w = now.getDay();
    var sameDay = w !== 0 && w !== 6 && now.getHours() < cutoff;
    if (!sameDay) ship = addBusinessDays(now, 1);
    var a = addBusinessDays(ship, min), b = addBusinessDays(ship, max);
    var f = function(d){ return d.toLocaleDateString('tr-TR', {day: 'numeric', month: 'short'}); };
    var fw = function(d){ return d.toLocaleDateString('tr-TR', {weekday: 'short', day: 'numeric', month: 'short'}); };
    box.querySelector('[data-ss-d="order"]').textContent = f(now);
    box.querySelector('[data-ss-d="ship"]').textContent = sameDay ? 'Bugün' : fw(ship);
    box.querySelector('[data-ss-d="arrive"]').textContent = f(a) + ' – ' + f(b);
  }

  function initSticky(root){
    var bar = document.querySelector('[data-ss-sticky]');
    var target = root.querySelector('[data-ss-buy]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', !show);
      document.body.classList.toggle('ss-has-sticky', show);
    });
    io.observe(target);
    bar.querySelector('[data-ss-sticky-btn]').addEventListener('click', function(){
      var b = document.getElementById('ss-buy');
      if (b) { b.scrollIntoView({behavior: 'smooth', block: 'center'}); }
    });
  }

  function initFaq(){
    document.querySelectorAll('[data-ss-faq]').forEach(function(list){
      var items = list.querySelectorAll('details');
      items.forEach(function(d){ d.addEventListener('toggle', function(){ if (d.open) items.forEach(function(o){ if (o !== d) o.open = false; }); }); });
    });
  }

  function initReveal(){
    var els = document.querySelectorAll('.ss-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {rootMargin: '0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initScrollLinks(){
    document.querySelectorAll('a[href="#ss-buy"]').forEach(function(a){
      a.addEventListener('click', function(ev){
        var b = document.getElementById('ss-buy');
        if (!b) return; ev.preventDefault(); b.scrollIntoView({behavior: 'smooth', block: 'center'});
      });
    });
  }

  function boot(){
    document.querySelectorAll('[data-ss-product]').forEach(function(root){
      initGallery(root); initBundles(root); initDelivery(root); initSticky(root);
    });
    initFaq(); initReveal(); initScrollLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
